import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { hasPermission } from "../session/demo-session.js";
import { useSession } from "../session/SessionContext.js";

export function RequirePermission({
  permissions,
  children,
}: {
  permissions?: readonly string[];
  children: ReactNode;
}) {
  const { session } = useSession();
  const location = useLocation();
  if (!session || !hasPermission(session, permissions)) {
    return <Navigate to="/acesso-negado" replace state={{ from: location.pathname }} />;
  }
  return children;
}
